export default "__VITE_ASSET__u2zAjh$H__"